import request from './request';

// 充值套餐列表
export function rechargePackages() {
  return request.get('/api/recharge/packagelist');
}

// 创建充值订单（支付宝）
export function createRechargeOrder(packageId, returnUrl) {
  return request.post('/api/recharge/createorder', {
    package_id: packageId,
    return_url: returnUrl || ''
  });
}

// 查询充值订单状态
export function rechargeOrderStatus(orderNo) {
  return request.get('/api/recharge/orderstatus', { order_no: orderNo });
}
